import React, { useCallback, useState, useEffect } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import notification from "../../utility/notification";
import { post } from "../../utility/fetch";

function QueueLabWork() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [payload, setPayload] = useState({
        patientId: 0,
        severity: 0,
        diagnosis: "",
        dateAndTimeInitiated: "",
        additionalNote: "",
        doctorId: 0,
        initiatedHealthCareProviderId: 0,
        testRequests: []
    });
    const { patientInfo, setPatientId, setPatientInfo } = usePatient();
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (patientInfo) {
            setPayload({
                patientId: patientInfo.patient.id,
                severity: patientInfo.severity,
                diagnosis: patientInfo.diagnosis,
                dateAndTimeInitiated: patientInfo.dateAndTimeInitiated,
                additionalNote: patientInfo.additionalNote,
                doctorId: patientInfo.doctor.id,
                initiatedHealthCareProviderId: patientInfo.initiatedHealthCareProvider.id,
                testRequests: patientInfo.testRequests.map(request => ({
                    categoryItemId: request.categoryItem.id
                }))
            });
        }
    }, [patientInfo]);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const close = () => {
        setIsModalOpen(false);
        navigate('/procedures');
    };

    const labSpecialists = [
        { name: 'Dr. Alice Smith', specialty: 'Hematology', value: 1 },
        { name: 'Dr. Bob Johnson', specialty: 'Microbiology', value: 2 },
        { name: 'Dr. Carol Williams', specialty: 'Pathology', value: 3 },
        { name: 'Dr. David Brown', specialty: 'Radiology', value: 4 },
        { name: 'Dr. Emma Davis', specialty: 'Immunology', value: 5 },
        { name: 'Dr. Frank Miller', specialty: 'Genetics', value: 6 },
        { name: 'Dr. Grace Wilson', specialty: 'Biochemistry', value: 7 },
        { name: 'Dr. Henry Moore', specialty: 'Cytology', value: 8 },
        { name: 'Dr. Irene Taylor', specialty: 'Virology', value: 9 },
        { name: 'Dr. Jack Anderson', specialty: 'Toxicology', value: 10 }
    ];

    const QueueRequest = async () => {
        setLoader(true);
        try {
            let res = await post("/patients/UpdatePatient", payload);
            if (res.patientId) {
                notification({ message: res?.messages || 'Patient updated successfully', type: "success" });
                setPatientId(res.patientId);
            }
        } catch (error) {
            notification({ message: 'An error occurred while updating patient', type: "error" });
        } finally {
            setLoader(false);
        }
    };

    const handleSelectChange = useCallback((value, name) => {
        setPayload(prevPayload => ({
            ...prevPayload,
            testRequests: prevPayload.testRequests.map((request, index) =>
                index === parseInt(name.replace('labSpecialist', '')) ? { categoryItemId: value?.value } : request
            )
        }));
    }, []);

    const handleTranscript = (transcript) => {
        setPayload(prevPayload => ({ ...prevPayload, additionalNote: prevPayload.additionalNote ? prevPayload.additionalNote + ' ' + transcript : transcript }));
    };

    return (
        <div className="w-100 m-t-40">
            <div className="m-t-20">
                <h2>Queue Lab Work</h2>
                <div className="tabs m-t-10 bold-text"></div>
                <div className="m-l-40 col-8 cards no-border p-20">
                    <div className="flex space-between">
                        <div className="col-6">
                            <TagInputs label="Patient's Name" value={`${patientInfo?.patient?.firstName} ${patientInfo?.patient?.lastName}`} readOnly />
                        </div>
                        <div className="col-6">
                            <TagInputs label='Clinic' value={patientInfo?.initiatedHealthCareProvider?.name} readOnly />
                        </div>
                    </div>
                    <div className="flex space-between">
                        <div className="col-6">
                            <TagInputs label="Doctor's Name" value={`${patientInfo?.doctor?.firstName} ${patientInfo?.doctor?.lastName}`} readOnly />
                        </div>
                        {/* <div className="col-6">
                            <TagInputs label='Severity' value={patientInfo?.severity} readOnly />
                        </div> */}
                    </div>
                    <div className="flex space-between">
                        <div className="col-6">
                            <TagInputs label='Date Initiated' value={new Date(patientInfo?.dateAndTimeInitiated).toLocaleDateString()} readOnly />
                        </div>
                        <div className="col-6">
                            <TagInputs label='Time Initiated' value={new Date(patientInfo?.dateAndTimeInitiated).toLocaleTimeString()} readOnly />
                        </div>
                    </div>

                    <table className="bordered-table m-b-20 m-t-20">
                        <thead>
                            <tr>
                                <th>Lab Request</th>
                                <th>Route Request to Technician</th>
                            </tr>
                        </thead>
                        <tbody>
                            {patientInfo?.testRequests?.map((request, index) => (
                                <tr key={index}>
                                    <td>{index + 1}. {request?.categoryItem?.name}</td>
                                    <td>
                                        <TagInputs
                                            label="Select Lab Specialist"
                                            options={labSpecialists.map(specialist => ({
                                                label: `${specialist.name} (${specialist.specialty})`,
                                                value: specialist.value
                                            }))}
                                            name={`labSpecialist${index}`}
                                            onChange={(e) => handleSelectChange(e, `labSpecialist${index}`)}
                                            isMulti={true}
                                            type='R-select'
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div>
                        <TagInputs label="Doctor's Diagnosis" type='textArea' value={patientInfo?.diagnosis} readOnly multiline />
                    </div>
                    <div>
                        <TagInputs label='Additional Notes' type='textArea' value={patientInfo?.additionalNote} readOnly multiline />
                    </div>
                    <button onClick={openModal} className="submit-btn m-t-20">Proceed With Request</button>
                </div>
            </div>
            {isModalOpen &&
                <SuccessModal Name={`${patientInfo?.patient?.firstName} ${patientInfo?.patient?.lastName}`} closeModal={close} />
            }
        </div>
    );
}

export default QueueLabWork;
